import { DEFINITIONS as SUMMARY_DEFINTIIONS } from '@xing-com/content-editor-plugin-summary';
import { DEFINITIONS as TITLE_DEFINITIONS } from '@xing-com/content-editor-plugin-title';

import {
  Serializer,
  titleSerializer,
  textSerializer,
  summarySerializer,
  TITLE_TYPENAME,
  SUMMARY_TYPENAME,
} from './index';

class ArticleHeaderSerializer {
  articleHeaderSerializer = null;

  constructor() {
    this.articleHeaderSerializer = new Serializer({
      nodeSerializers: [titleSerializer, textSerializer, summarySerializer],
      markSerializers: [],
    });
  }

  serialize(blocks) {
    const [title, summary] = this.articleHeaderSerializer.serialize(
      blocks.filter(
        (block) =>
          (block && block.type === TITLE_DEFINITIONS.type) ||
          (block && block.type === SUMMARY_DEFINTIIONS.type)
      )
    );

    return { ...title, ...summary };
  }

  deserialize(blocks) {
    const [title, summary] = this.articleHeaderSerializer.deserialize(
      blocks.filter(
        (block) =>
          (block && block.__typename === TITLE_TYPENAME) ||
          (block && block.__typename === SUMMARY_TYPENAME)
      )
    );
    return { title, summary };
  }
}

const articleHeaderSerializer = new ArticleHeaderSerializer();

export { articleHeaderSerializer };
